// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthModal2_modal__305iz {
  background-color: #F6F7F8;
  padding-left: 0;
  padding-right: 0;
}
@media (min-width: 576px) {
  .AuthModal2_modal__305iz {
    padding-left: 40px;
    padding-right: 40px;
  }
}
.AuthModal2_modal__305iz .modal__overlay, .AuthModal2_modal__305iz .modal__close-btn {
  display: none;
}
.AuthModal2_modal__305iz .modal__inner {
  max-width: 560px;
  position: static;
  background: none;
}
@media (min-width: 576px) {
  .AuthModal2_modal__305iz .modal__inner {
    background-color: var(--white);
  }
}

.AuthModal2_header__qUPHM {
  position: absolute;
  left: 0;
  right: 0;
  top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1200px) {
  .AuthModal2_header__qUPHM {
    top: 22px;
  }
  .AuthModal2_header__qUPHM .AuthModal2_logo__Aqdh1 svg, .AuthModal2_header__qUPHM .AuthModal2_logo__Aqdh1 img {
    max-width: 150px;
    max-height: 150px;
  }
}
@media (max-width: 640px) {
  .AuthModal2_header__qUPHM .AuthModal2_logo__Aqdh1 svg,
  .AuthModal2_header__qUPHM .AuthModal2_logo__Aqdh1 img {
    max-width: 100px;
    max-height: 100px;
  }
}

.AuthModal2_logo__Aqdh1 svg, .AuthModal2_logo__Aqdh1 img {
  max-width: 200px;
  max-height: 120px;
  height: auto;
}

div.AuthModal2_lang__L7lfq {
  position: absolute;
  top: 0;
  right: 12px;
}
@media (min-width: 640px) {
  div.AuthModal2_lang__L7lfq {
    right: 30px;
  }
}

.AuthModal2_logoTxt__ngvtA {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--gray-500);
  display: flex;
}

.AuthModal2_title__mGv6m,
.AuthModal2_txt__vtRwA {
  text-align: left;
}
@media (min-width: 576px) {
  .AuthModal2_title__mGv6m,
  .AuthModal2_txt__vtRwA {
    text-align: center;
  }
}

.AuthModal2_title__mGv6m {
  margin-bottom: 8px;
}

.AuthModal2_txt__vtRwA {
  font-size: 14px;
  line-height: 16px;
}

@media (min-width: 1200px) {
  .AuthModal2_btnAuth__m7pVn {
    max-width: 204px;
    width: 100%;
  }
}
.AuthModal2_btnAuth__m7pVn .btn__icon {
  display: flex;
  align-items: center;
  top: calc(50% + 1px);
}

@media (min-width: 1200px) {
  .AuthModal2_btnBack__2VNc8 {
    max-width: 122px;
    width: 100%;
  }
}

.AuthModal2_change-btn__kZewq {
  background: #EFF3F5;
  font-weight: 400;
  color: #3D525C;
  max-width: 146px;
  width: 100%;
  margin-right: auto;
  padding: 12px;
}
@media (max-width: 1200px) {
  .AuthModal2_change-btn__kZewq {
    max-width: 180px;
  }
}
@media (max-width: 640px) {
  .AuthModal2_change-btn__kZewq {
    max-width: 130px;
  }
}

.AuthModal2_authBottom__gNelY {
  display: flex;
  justify-content: space-between;
  grid-gap: 12px;
  margin-top: 60px;
}
@media (min-width: 1200px) {
  .AuthModal2_authBottom__gNelY {
    justify-content: flex-end;
    margin-top: 24px;
  }
}
@media (min-width: 1200px) {
  .AuthModal2_authBottom--center__\\+\\+7Qm {
    justify-content: center;
  }
}

.AuthModal2_secondEnd__QqyDz {
  font-size: 12px;
  line-height: 16px;
  margin-top: 20px;
}

.AuthModal2_resendBtn__axMFC {
  text-decoration: underline;
  letter-spacing: -0.02em;
  color: var(--accent-color);
  margin-left: 4px;
  font-weight: 600;
}
@media (hover: hover) {
  .AuthModal2_resendBtn__axMFC:hover {
    text-decoration: none;
  }
}

.AuthModal2_inputWrap__5CKo6 {
  position: relative;
}
.AuthModal2_inputWrap__5CKo6 .error-text {
  margin-top: 2px;
}
.AuthModal2_inputWrap__5CKo6 .AuthModal2_email-input__qC7dG {
  font-weight: 400;
}

div.AuthModal2_txtPrivacy__vMDlG {
  margin-top: 16px;
}

.AuthModal2_country__c6OIf .PhoneInputCountrySelectArrow {
  color: var(--text-color);
  width: 6px;
  height: 6px;
  border-color: var(--text-color);
  opacity: 1;
}
.AuthModal2_country__c6OIf .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
  box-shadow: none;
}
.AuthModal2_country__c6OIf .PhoneInputCountrySelect:focus ~ .PhoneInputCountrySelectArrow {
  transform: rotate(225deg) translate(-2px, -2px);
}
.AuthModal2_country__c6OIf .PhoneInputCountryIcon {
  flex-shrink: 0;
  background: none;
  box-shadow: none;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.AuthModal2_country__c6OIf .PhoneInputCountryIcon::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: inherit;
  border: 2px solid var(--white);
}
.AuthModal2_country__c6OIf .PhoneInputCountryIconImg {
  object-fit: cover;
  object-position: center;
  border-radius: 100%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid var(--white);
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/AuthModal2/AuthModal2.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AACF;AACE;EALF;IAMI,kBAAA;IACA,mBAAA;EAEF;AACF;AAEM;EAEE,aAAA;AADR;AAIM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFR;AAIQ;EALF;IAMI,8BAAA;EADR;AACF;;AAOA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAME;EATF;IAUI,SAAA;EAHF;EAMI;IACE,gBAAA;IACA,iBAAA;EAJN;AACF;AAQE;EAEI;;IAEE,gBAAA;IACA,iBAAA;EAPN;AACF;;AAaE;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;AAVJ;;AAcA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;AAXF;AAaE;EALF;IAMI,WAAA;EAVF;AACF;;AAaA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;AAVF;;AAaA;;EAEE,gBAAA;AAVF;AAYE;EAJF;;IAKI,kBAAA;EARF;AACF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;AARF;;AAYE;EADF;IAEI,gBAAA;IACA,WAAA;EARF;AACF;AAYM;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAVR;;AAiBE;EADF;IAEI,gBAAA;IACA,WAAA;EAbF;AACF;;AAgBA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAbF;AAeE;EATF;IAUI,gBAAA;EAZF;AACF;AAcE;EAbF;IAcI,gBAAA;EAXF;AACF;;AAcA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;AAXF;AAaE;EANF;IAOI,yBAAA;IACA,gBAAA;EAVF;AACF;AAaI;EADF;IAEI,uBAAA;EAVJ;AACF;;AAcA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AAXF;AAaE;EACE;IACE,qBAAA;EAXJ;AACF;;AAeA;EACE,kBAAA;AAZF;AAeI;EACE,eAAA;AAbN;AAiBE;EACE,gBAAA;AAfJ;;AAmBA;EACE,gBAAA;AAhBF;;AAqBI;EACE,wBAAA;EACA,UAAA;EACA,WAAA;EACA,+BAAA;EACA,UAAA;AAlBN;AAsBM;EACE,gBAAA;AApBR;AAsBM;EACE,+CAAA;AApBR;AAwBI;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAtBN;AAwBM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,8BAAA;AAtBR;AA0BI;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uDAAA;EACA,8BAAA;AAxBN","sourcesContent":[".modal {\r\n  background-color: #F6F7F8;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n\r\n  @media (min-width: 576px) {\r\n    padding-left: 40px;\r\n    padding-right: 40px;\r\n  }\r\n\r\n  :global {\r\n    .modal {\r\n      &__overlay,\r\n      &__close-btn {\r\n        display: none;\r\n      }\r\n\r\n      &__inner {\r\n        max-width: 560px;\r\n        position: static;\r\n        background: none;\r\n\r\n        @media (min-width: 576px) {\r\n          background-color: var(--white);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.header {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 42px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  \r\n  @media (max-width: 1200px) {\r\n    top: 22px;\r\n\r\n    .logo {\r\n      svg, img {\r\n        max-width: 150px;\r\n        max-height: 150px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 640px) {\r\n    .logo {\r\n      svg,\r\n      img {\r\n        max-width: 100px;\r\n        max-height: 100px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.logo {\r\n  svg, img {\r\n    max-width: 200px;\r\n    max-height: 120px;\r\n    height: auto;\r\n  }\r\n}\r\n\r\ndiv.lang {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 12px;\r\n\r\n  @media (min-width: 640px) {\r\n    right: 30px;\r\n  }\r\n}\r\n\r\n.logoTxt {\r\n  position: absolute;\r\n  bottom: 24px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  color: var(--gray-500);\r\n  display: flex;\r\n}\r\n\r\n.title,\r\n.txt {\r\n  text-align: left;\r\n\r\n  @media (min-width: 576px) {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.title {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.txt {\r\n  font-size: 14px;\r\n  line-height: 16px;\r\n}\r\n\r\n.btnAuth {\r\n  @media (min-width: 1200px) {\r\n    max-width: 204px;\r\n    width: 100%;\r\n  }\r\n\r\n  :global {\r\n    .btn {\r\n      &__icon {\r\n        display: flex;\r\n        align-items: center;\r\n        top: calc(50% + 1px);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btnBack {\r\n  @media (min-width: 1200px) {\r\n    max-width: 122px;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.change-btn {\r\n  background: #EFF3F5;\r\n  font-weight: 400;\r\n  color: #3D525C;\r\n  max-width: 146px;\r\n  width: 100%;\r\n  margin-right: auto;\r\n  padding: 12px;\r\n\r\n  @media (max-width: 1200px) {\r\n    max-width: 180px;\r\n  }\r\n\r\n  @media (max-width: 640px) {\r\n    max-width: 130px;\r\n  }\r\n}\r\n\r\n.authBottom {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  grid-gap: 12px;\r\n  margin-top: 60px;\r\n\r\n  @media (min-width: 1200px) {\r\n    justify-content: flex-end;\r\n    margin-top: 24px;\r\n  }\r\n\r\n  &--center {\r\n    @media (min-width: 1200px) {\r\n      justify-content: center;\r\n    }\r\n  }\r\n}\r\n\r\n.secondEnd {\r\n  font-size: 12px;\r\n  line-height: 16px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.resendBtn {\r\n  text-decoration: underline;\r\n  letter-spacing: -0.02em;\r\n  color: var(--accent-color);\r\n  margin-left: 4px;\r\n  font-weight: 600;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.inputWrap {\r\n  position: relative;\r\n\r\n  :global {\r\n    .error-text {\r\n      margin-top: 2px;\r\n    }\r\n  }\r\n\r\n  .email-input {\r\n    font-weight: 400;\r\n  }\r\n}\r\n\r\ndiv.txtPrivacy {\r\n  margin-top: 16px;\r\n}\r\n\r\n.country {\r\n  :global {\r\n    .PhoneInputCountrySelectArrow {\r\n      color: var(--text-color);\r\n      width: 6px;\r\n      height: 6px;\r\n      border-color: var(--text-color);\r\n      opacity: 1;\r\n    }\r\n\r\n    .PhoneInputCountrySelect:focus {\r\n      & + .PhoneInputCountryIcon--border {\r\n        box-shadow: none;\r\n      }\r\n      & ~ .PhoneInputCountrySelectArrow {\r\n        transform: rotate(225deg) translate(-2px, -2px);\r\n      }\r\n    }\r\n\r\n    .PhoneInputCountryIcon {\r\n      flex-shrink: 0;\r\n      background: none;\r\n      box-shadow: none;\r\n      width: 24px;\r\n      height: 24px;\r\n      border-radius: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      position: relative;\r\n\r\n      &::after {\r\n        content: '';\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        border-radius: inherit;\r\n        border: 2px solid var(--white);\r\n      }\r\n    }\r\n\r\n    .PhoneInputCountryIconImg {\r\n      object-fit: cover;\r\n      object-position: center;\r\n      border-radius: 100%;\r\n      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1607843137);\r\n      border: 1px solid var(--white);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `AuthModal2_modal__305iz`,
	"header": `AuthModal2_header__qUPHM`,
	"logo": `AuthModal2_logo__Aqdh1`,
	"lang": `AuthModal2_lang__L7lfq`,
	"logoTxt": `AuthModal2_logoTxt__ngvtA`,
	"title": `AuthModal2_title__mGv6m`,
	"txt": `AuthModal2_txt__vtRwA`,
	"btnAuth": `AuthModal2_btnAuth__m7pVn`,
	"btnBack": `AuthModal2_btnBack__2VNc8`,
	"change-btn": `AuthModal2_change-btn__kZewq`,
	"authBottom": `AuthModal2_authBottom__gNelY`,
	"authBottom--center": `AuthModal2_authBottom--center__++7Qm`,
	"secondEnd": `AuthModal2_secondEnd__QqyDz`,
	"resendBtn": `AuthModal2_resendBtn__axMFC`,
	"inputWrap": `AuthModal2_inputWrap__5CKo6`,
	"email-input": `AuthModal2_email-input__qC7dG`,
	"txtPrivacy": `AuthModal2_txtPrivacy__vMDlG`,
	"country": `AuthModal2_country__c6OIf`
};
export default ___CSS_LOADER_EXPORT___;
